import React, { useEffect, useState } from "react";
import { Button, Form, Offcanvas } from "react-bootstrap";
import {
  useConsultFeedback,
  useGenerateCartLink,
  usePrescriptionCanvas,
  useSetConsultFeedback,
  useSlotBookingStoreFeedback,
} from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import {
  doctor,
  getCurrentUserRole,
  required,
} from "modules/utilities/utility";
import { useNavigate } from "react-router-dom";
import { useUpdateFeedBack } from "../feedback_form/store";

function PrescriptionOrder({ customer, doctorForm }) {
  const { setProductCanvas } = useGenerateCartLink();
  const { prescriptionCanvas, setPrescriptionForm } = usePrescriptionCanvas();
  const { doctorFlag, doctorPrescriptionForm } = useSlotBookingStoreFeedback();

  useEffect(() => {
    if (prescriptionCanvas) {
      handleShow();
    }
  }, [prescriptionCanvas]);
  const [show, setShow] = useState(false);
  const handleShow = () => {
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
    setPrescriptionForm(false);
  };
  const { setToaster } = useToast();

  const [customConsultFeedbackForm, setCustomConsultFeedbackForm] = useState(
    {}
  );

  const [fieldValidations, setFieldValidations] = useState({
    "Hair Fall duration": false,
    "Past Hair Loss Treatments": false,
    "Medical History / Current medication": false,
    "Dandruff condition/ Scalp type": false,
    "Set Expectations": false,
    "Additional Notes (if any)": false,
  });

  const { fetchFeedbackData } = useConsultFeedback();
  const { setConsultFeedback, isLoading } = useSetConsultFeedback();

  useEffect(() => {
    show && fetchFeedbackData(customer.id, setCustomConsultFeedbackForm);
  }, [fetchFeedbackData, customer.id, show]);

  useEffect(() => {
    setFieldValidations(customConsultFeedbackForm);
  }, [customConsultFeedbackForm]);

  const handleFieldChange = (field, value) => {
    setCustomConsultFeedbackForm({
      ...customConsultFeedbackForm,
      [field]: value,
    });
    setFieldValidations({
      ...fieldValidations,
      ...customConsultFeedbackForm,
      [field]: value.trim() !== "",
    });
  };

  const isFormValid =
    Object.values(fieldValidations).every(Boolean) &&
    Object.values(customConsultFeedbackForm).every(Boolean);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (isFormValid) {
      setConsultFeedback(
        customer.id,
        customConsultFeedbackForm,
        setToaster,
        fetchFeedbackData,
        handleClose
      );
      !doctorFlag && prescriptionCanvas && setProductCanvas(true);
      doctorPrescriptionForm(false);
    }
  };

  const fields = [
    "Hair Fall duration",
    "Past Hair Loss Treatments",
    "Medical History / Current medication",
    "Dandruff condition/ Scalp type",
    "Set Expectations",
    "Additional Notes (if any)",
  ];

  return (
    <>
      <Button onClick={handleShow} style={{ flex: 1 }} className="py-2">
        Update
      </Button>
      <Offcanvas
        placement="end"
        name="Edit"
        show={show}
        onHide={handleClose}
        style={{ width: "30%" }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Consult Call feedback</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="d-flex flex-column align-items-center">
          <Form className="w-100 mb-3" onSubmit={handleSubmit}>
            {fields.map((field) => {
              return (
                <Form.Group key={field}>
                  <Form.Label>{field}</Form.Label>
                  <Form.Control
                    required
                    as="textarea"
                    rows={field === "Additional Notes (if any)" ? 4 : 2}
                    value={customConsultFeedbackForm[field] || ""}
                    onChange={(event) => {
                      handleFieldChange(field, event.target.value);
                    }}
                  />
                  {!fieldValidations[field] &&
                    !customConsultFeedbackForm[field] && (
                      <div className="text-danger">This field is required.</div>
                    )}
                </Form.Group>
              );
            })}
            <Button
              type="submit"
              className="text-centre w-100 my-2"
              disabled={!isFormValid || isLoading}
            >
              {prescriptionCanvas
                ? doctorFlag
                  ? `Save`
                  : `Save and Send Cart Link`
                : `Submit`}
            </Button>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default PrescriptionOrder;
